import { Component, Inject, OnInit } from "@angular/core";
import { MarkdownParser } from "@common/lib/chat-ai/chat-ai.service";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogComponent, DialogResolveData } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";
import { AuditService, IChatAudit } from "app/audit/audit.service";

export interface IAiConversationDetailsDialogData {
    conversationId: string;
    userName: string;
}

export interface IChatAuditWithRendered extends IChatAudit {
    renderUserMessage?: string;
    renderAssistantMessage?: string;
    isUserMessageCopied?: boolean;
    isAssistantMessageCopied?: boolean;
}

@Component({
    selector: "adapt-ai-conversation-details-dialog",
    standalone: false,
    templateUrl: "./ai-conversation-details-dialog.component.html",
    styleUrl: "./ai-conversation-details-dialog.component.css",
})
export class AiConversationDetailsDialogComponent extends BaseDialogComponent<IAiConversationDetailsDialogData, void> implements OnInit {
    public readonly dialogName = "AiConversationDetails";

    public chatAudits: IChatAuditWithRendered[] = [];

    public constructor(
        @Inject(ADAPT_DIALOG_DATA) public data: IAiConversationDetailsDialogData,
        private auditService: AuditService,
    ) {
        super(DialogResolveData.NotRequired);
    }

    public async ngOnInit() {
        this.chatAudits = await this.auditService.getChatForConversation(this.data.conversationId);
        this.chatAudits.forEach((audit) => {
            audit.timestamp = new Date(audit.timestamp);
            // In some cases, UserMessageTimestamp might be missing or invalid, so we fall back to the main timestamp
            // - this is from the blob table storage directly where timestamp is lowercase but other properties are uppercase
            // - timestamp, rowKey, partitionKey, etag are all written automatically by Azure Table Storage
            audit.UserMessageTimestamp = audit.UserMessageTimestamp ? new Date(audit.UserMessageTimestamp) : audit.timestamp;
            audit.renderUserMessage = MarkdownParser.processSync(audit.UserMessage).toString();
            audit.renderAssistantMessage = MarkdownParser.processSync(audit.AssistantMessage).toString();
        });
        this.chatAudits.sort((a, b) => a.UserMessageTimestamp.getTime() - b.UserMessageTimestamp.getTime());
        this.isInitialised = true;
    }

    public onCopyButtonClick(message: IChatAuditWithRendered, isUserMessage: boolean) {
        const textToCopy = isUserMessage ? message.UserMessage : message.AssistantMessage;
        navigator.clipboard?.writeText(textToCopy);

        message.isUserMessageCopied = isUserMessage;
        message.isAssistantMessageCopied = !isUserMessage;

        setTimeout(() => {
            if (isUserMessage) {
                message.isUserMessageCopied = false;
            } else {
                message.isAssistantMessageCopied = false;
            }
        }, 2500);
    }
}
